<template>
  <div>
    <div class="columns is-centered">
      <div class="column is-half">
        <form ref="form">
          <b-field label="デバイスID">
            <b-input v-model="deviceId" type="text" value="device_id" maxlength="256" required>
            </b-input>
          </b-field>
          <b-button size="is-large" :disabled="isDisabled" @click="saveData">保存</b-button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Kitting',
  data() {
    return {
      deviceId: '',
      isDisabled: true,
    };
  },
  watch: {
    deviceId: function () {
      const valid = this.$refs.form.checkValidity();
      this.isDisabled = !valid;
    },
  },
  methods: {
    saveData() {
      console.log(this);
      console.log(this.deviceId);
      localStorage.setItem('deviceId', this.deviceId);
      setTimeout(() => {
        this.$router.push('/');
      }, 1000);
    },
  },
};
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/Kitting.vue